import { render } from "./SizeForm.vue?vue&type=template&id=1b55e159&scoped=true"
import script from "./SizeForm.vue?vue&type=script&lang=js"
export * from "./SizeForm.vue?vue&type=script&lang=js"

import "./SizeForm.vue?vue&type=style&index=0&id=1b55e159&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b55e159"]])

export default __exports__